import React, { useState, useEffect } from 'react';
import Alert from '../../ui/Alert';
import LoadingCircle from '../../ui/LoadingCircle';
import { getFSCDisclaimer } from '../../../utils/ConfigWebAPIUtils';
export default function FSCDisclaimer({ onHide }) {
    const [disclaimer, setDisclaimer] = useState('');
    const [loading, setLoading] = useState(true);
    async function fetchFSCDisclaimer() {
        try {
            const { data: { disclaimer }, } = await getFSCDisclaimer();
            setDisclaimer(disclaimer);
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchFSCDisclaimer();
    }, []);
    if (loading) {
        return React.createElement(LoadingCircle, null);
    }
    return (React.createElement(Alert, { title: disclaimer, type: "warning", canClose: !!onHide, onClose: onHide }));
}
